import { useCallback, useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";

import RightChevron from "../../../../../src/assets/images/chevron-left-color.svg";
import ProgressBar from "../../../../shared/LinearProgressBar";

import Button from "../ButtonComponent";

import HeaderModule from "../ModuleHeaderComponent";

import { BUTTON_VARIANTS } from "../constant";

import CourseQuestionCards from "../CourseQuestionCards";
// import ChapterCompleteSuccessfulComponent from "../ChapterSuccessfulComponent";

import ModuleStatusComponent from "../ModuleStatusComponent";

import Shimmer from "../ShimmerComponent";

import { useSavePostChapterAssessment } from "./mutation";
import { useGetPostModuleAssessmentQuestion } from "./queries";

import styles from "./styles.module.scss";
import AssessmentExitModal from "../AssessmentExitModal";
import { ASSESSMENT_ALLOWED, LMS_MODULE_NAME } from "../../../../utils/cookiesmanager";
import { getTranslatedText } from "../../../../utils/getTranslatedText";
import { useGetTranslatedText } from "../queries";

const PostModuleAssessment = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [animate, setAnimate] = useState(false);
  const [show, setShow] = useState(false);
  const [moduleResult, setModuleResult] = useState(0);
  const [allowLeave, setAllowLeave] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const [searchParams] = useSearchParams();

  const courseId = searchParams.get("courseId");
  const moduleId = searchParams.get("moduleId");
  const courseName = searchParams.get("courseName");
  const moduleName = localStorage.getItem(LMS_MODULE_NAME)

  const languageid = localStorage.getItem("l_id") || 1;

  const {data:translatedTextResponse} = useGetTranslatedText(languageid)
        
  const {data:translatedText = []} = translatedTextResponse || {};

  const navigate = useNavigate();

  const { data: postAssessmentChapterQuestion, isLoading , isFetching } =
    useGetPostModuleAssessmentQuestion({ courseId, moduleId, languageid });

  const { mutate, isPending } = useSavePostChapterAssessment();

  const { data: postAssessmentChapterQuestionData } =
    postAssessmentChapterQuestion || {};

  const { response } = postAssessmentChapterQuestionData || {};

  const handleNext = () => {
    const currentQuestion = response?.[activeIndex];

    if (!selectedAnswers[currentQuestion?.assQuestionId]) {
      toast.error("Please select an answer");
      return;
    }

    if (activeIndex === response.length - 1) {
      const payload = {
        courseId,
        moduleId,
        questionArray: Object.entries(selectedAnswers).map(
          ([assQuestionID, assAnswerID]) => ({
            assQuestionID,
            assAnswerID,
          }),
        ),
      };

      mutate(payload, {
        onSuccess(data) {
          const { status, error } = data;

          if (!status) {
            throw new Error(error);
          }

          setModuleResult(data?.data?.response);
          setShow(true);
          setActiveIndex((prev) => prev + 1);
        },
        onError(error) {
          const errorMessage =
            error instanceof Error ? error.message : String(error);
          toast(errorMessage, { type: "error" });
        },
        onSettled() {},
      });
      return;
    }

    setAnimate(true);
    setAnimate(false);
    setActiveIndex((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (activeIndex === 0 || activeIndex < 0) return;

    setActiveIndex((prev) => prev - 1);
  };

  const handleRedirection = () => {
    setShow(false);
    navigate(
      `/user/post-module-feedback?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
    );
  };

  const handleTryAgain = () => {
    setActiveIndex(0);
    setShow(false);
    setSelectedAnswers({});
    navigate(
      `/user/post-module-assessment?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
    );
  };

  const handleBack = () => {
    setShowWarning(true);
  };

  const handleContinueAssessment = () => {
    setShowWarning(false);
    setAllowLeave(false);
  };

  const handleExit = () => {
    sessionStorage.removeItem(ASSESSMENT_ALLOWED);
    navigate(`/user/module-list?courseId=${courseId}&courseName=${courseName}`);
  };

  useEffect(() => {
    // Add a dummy history entry
    window.history.pushState(
      { guard: true },
      "",
      `${window.location.pathname}?${searchParams.toString()}`,
    );

    const handlePopState = () => {
      if (!allowLeave) {
        setShowWarning(true);

        // Re-push state to stop navigation
        window.history.pushState({ guard: true }, "", window.location.pathname);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [allowLeave]);

  useEffect(() => {
    const allowed = sessionStorage.getItem(ASSESSMENT_ALLOWED);
  
    if (!allowed) {
      navigate(
        `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
        { replace: true }
      );
    }
  }, []);

  const currentQuestion = response?.[activeIndex];

  const handleModuleExit = () => {
    navigate(
        `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
        { replace: true }
      );
  }

  const isCurrentQuestionAnswered =
    !!selectedAnswers[currentQuestion?.assQuestionId];

  const handleQuestionAnswer = useCallback((question, option) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [question.assQuestionId]: option.assAnswerId,
    }));
  }, []);

  const isLastQuestion = response && activeIndex === response.length - 1;

  return (
    <>
      <div className={styles.page}>
        <HeaderModule
          title={`${getTranslatedText(translatedText , "label_module_post_assessment" , "Module Assessment")}  - ${getTranslatedText(translatedText , "label_post_assessment" , "Post Assessment")}`}
          className={styles["header-title"]}
          onBackClick={handleBack}
        />
        <div className={styles["container-wrapper"]}>
          <div className={styles["content-part"]}>
            <p className={styles.title}>{moduleName}</p>
            <ProgressBar current={activeIndex} total={response?.length} />
            {isLoading || isFetching ? (
              <Shimmer width="90%" height="324px" borderRadius="14px" />
            ) : (
              <CourseQuestionCards
                questionsList={response}
                handleQuestionAnswer={handleQuestionAnswer}
                activeIndex={activeIndex}
                animate={animate}
                selectedAnswers={selectedAnswers}
              />
            )}
          </div>
        </div>
        <div className={styles["bottom-wrapper"]}>
          <Button
            label="Previous"
            buttonVariant={BUTTON_VARIANTS.SECONDARY}
            className={styles["button-class"]}
            onClick={handlePrevious}
            disabled={activeIndex === 0 || activeIndex < 0}
            startIcon={
              <img
                className={styles["left-chevron"]}
                src={RightChevron}
                alt="chevron"
              />
            }
          />
          <Button
            loading={isPending}
            label={
              isPending ? "Submitting..." : isLastQuestion ? "Submit" : "Next"
            }
            buttonVariant={BUTTON_VARIANTS.PRIMARY}
            className={styles["button-class"]}
            onClick={handleNext}
            disabled={!isCurrentQuestionAnswered || isPending}
          />
        </div>
        <ToastContainer />
      </div>
      {show && (
        <ModuleStatusComponent
          marks={moduleResult}
          handleContinue={handleRedirection}
          handleTryAgain={handleTryAgain}
          handleExit={handleModuleExit}
          show={show}
          passingMarks={50}
        />
      )}
      {showWarning && (
        <AssessmentExitModal
          handleContinueAssessment={handleContinueAssessment}
          handleExit={handleExit}
          show={showWarning}
        />
      )}
    </>
  );
};

export default PostModuleAssessment;
